/** Hostnames (and subdomains) treated as “known” branded social — use API-provided icon. */
const KNOWN_SOCIAL_ROOTS = [
  'facebook.com',
  'fb.com',
  'fb.me',
  'instagram.com',
  'messenger.com',
  'snapchat.com',
  'linkedin.com',
  'twitter.com',
  'x.com',
  'youtube.com',
  'youtu.be',
  'whatsapp.com',
  'wa.me',
  'telegram.org',
  'telegram.me',
  't.me'
] as const

function hostnameMatchesKnownRoot(host: string): boolean {
  const h = host.toLowerCase().replace(/^www\./, '')
  return KNOWN_SOCIAL_ROOTS.some((root) => h === root || h.endsWith(`.${root}`))
}

/**
 * Whether URL should use the remote favicon/icon from the API (known social host).
 */
export function isKnownSocialMediaUrl(rawUrl: string | null | undefined): boolean {
  const trimmed = rawUrl?.trim()
  if (!trimmed) return false
  let candidate = trimmed
  if (!/^https?:\/\//i.test(candidate)) {
    candidate = `https://${candidate}`
  }
  try {
    const { hostname } = new URL(candidate)
    return hostnameMatchesKnownRoot(hostname)
  } catch {
    return false
  }
}
